import React, { useEffect, useState } from 'react';
import {
  Form,
  Input,
  Row,
  Col,
  Table,
  Space,
  Button,
  Select,
  Cascader,
  DatePicker,
  Popconfirm,
  InputNumber,
} from 'antd';
import formatAmount from 'indian-currency-formatter';

import { DeleteOutlined } from '@ant-design/icons';

import getFormattedLocations from '../../utils/getFormattedLocations';
import guid from '../../utils/guid';

import * as Config from '../../appConfig';

import './style.css';

const { Option } = Select;
const { RangePicker } = DatePicker;

const EmployeeBulkInsert = ({
  locations,
  designations,
  portfolios,
  productTypes,
  stages,
  onSave,
}) => {
  const [form] = Form.useForm();
  const [dataSource, setDataSource] = useState([]);
  const [inProgress, setInProgress] = useState(false);

  const columns = [
    {
      dataIndex: 'remove',
      key: 'remove',
      width: '50px',
      render: (_, record) => {
        return (
          <Button
            type="secondary"
            onClick={() => {
              removeRow(record.key);
            }}
            icon={<DeleteOutlined />}
            disabled={dataSource.length <= 1}
          ></Button>
        );
      },
    },
    {
      title: 'Location *',
      dataIndex: 'location',
      key: 'location',
      width: '200px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['location', record.key]}
            fieldKey={['location', record.key]}
            key={`location_${record.key}`}
            style={{
              margin: 0,
            }}
            rules={[
              {
                required: true,
                message: false,
              },
            ]}
          >
            <Cascader options={getFormattedLocations(locations)} />
          </Form.Item>
        );
      },
    },
    {
      title: 'First Name *',
      dataIndex: 'first_name',
      key: 'first_name',
      width: '150px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['first_name', record.key]}
            fieldKey={['first_name', record.key]}
            style={{
              margin: 0,
            }}
            rules={[
              {
                required: true,
                message: false,
              },
            ]}
          >
            <Input placeholder="First Name" />
          </Form.Item>
        );
      },
    },
    {
      title: 'Last Name *',
      dataIndex: 'last_name',
      key: 'last_name',
      width: '150px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['last_name', record.key]}
            fieldKey={['last_name', record.key]}
            style={{
              margin: 0,
            }}
            rules={[
              {
                required: true,
                message: false,
              },
            ]}
          >
            <Input placeholder="Last Name" />
          </Form.Item>
        );
      },
    },
    {
      title: 'Designation *',
      dataIndex: 'designation',
      key: 'designation',
      width: '150px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['designation', record.key]}
            fieldKey={['designation', record.key]}
            style={{
              margin: 0,
            }}
            rules={[
              {
                required: true,
                message: false,
              },
            ]}
          >
            <Select>
              {designations &&
                designations.map((category) => (
                  <Option value={category.id}>{category.name}</Option>
                ))}
            </Select>
          </Form.Item>
        );
      },
    },
    {
      title: 'Portfolio *',
      dataIndex: 'portfolio',
      key: 'portfolio',
      width: '125px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['portfolio', record.key]}
            fieldKey={['portfolio', record.key]}
            style={{
              margin: 0,
            }}
            rules={[
              {
                required: true,
                message: false,
              },
            ]}
          >
            <Select>
              {portfolios &&
                portfolios.map((category) => (
                  <Option value={category.id}>{category.name}</Option>
                ))}
            </Select>
          </Form.Item>
        );
      },
    },
    {
      title: 'Product',
      dataIndex: 'productType',
      key: 'productType',
      width: '125px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['productType', record.key]}
            fieldKey={['productType', record.key]}
            style={{
              margin: 0,
            }}
            rules={[
              {
                message: false,
              },
            ]}
          >
            <Select>
              {productTypes &&
                productTypes.map((category) => (
                  <Option value={category.id}>{category.name}</Option>
                ))}
            </Select>
          </Form.Item>
        );
      },
    },
    {
      title: 'Stage',
      dataIndex: 'stage',
      key: 'stage',
      width: '125px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['stage', record.key]}
            fieldKey={['stage', record.key]}
            style={{
              margin: 0,
            }}
            rules={[
              {
                message: false,
              },
            ]}
          >
            <Select>
              {stages &&
                stages.map((category) => (
                  <Option value={category.id}>{category.name}</Option>
                ))}
            </Select>
          </Form.Item>
        );
      },
    },
    {
      title: 'Aadhar(Last 4 digit) *',
      dataIndex: 'aadhar',
      key: 'aadhar',
      width: '75px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['aadhar', record.key]}
            fieldKey={['aadhar', record.key]}
            style={{
              margin: 0,
            }}
            rules={[
              {
                required: true,
                message: false,
              },
              {
                pattern: /^(?:\d*)$/,
                message: false,
              },
              {
                pattern: /^[\d]{4}$/,
                message: false,
              },
            ]}
          >
            <Input placeholder="Aadhar(Last 4 digit only)" />
          </Form.Item>
        );
      },
    },
    {
      title: 'Mobile 1 *',
      dataIndex: 'phone_1',
      key: 'phone_1',
      width: '150px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['phone_1', record.key]}
            fieldKey={['phone_1', record.key]}
            style={{
              margin: 0,
            }}
            rules={[
              {
                required: true,
                message: false,
              },
            ]}
          >
            <Input placeholder="Mobile 1" />
          </Form.Item>
        );
      },
    },
    {
      title: 'DOJ *',
      dataIndex: 'date_of_joining',
      key: 'date_of_joining',
      width: '150px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['date_of_joining', record.key]}
            fieldKey={['date_of_joining', record.key]}
            rules={[{ required: true, message: false }]}
            style={{
              margin: 0,
            }}
          >
            <DatePicker format={Config.DATE_FORMAT_INPUT} />
          </Form.Item>
        );
      },
    },
    {
      title: 'PAN',
      dataIndex: 'pan',
      key: 'pan',
      width: '125px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['pan', record.key]}
            fieldKey={['pan', record.key]}
            style={{
              margin: 0,
            }}
            rules={[
              {
                pattern: /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/,
                message: false,
              },
            ]}
          >
            <Input placeholder="PAN" />
          </Form.Item>
        );
      },
    },
    {
      title: 'Mobile 2',
      dataIndex: 'phone_2',
      key: 'phone_2',
      width: '150px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['phone_2', record.key]}
            fieldKey={['phone_2', record.key]}
            style={{
              margin: 0,
            }}
          >
            <Input placeholder="Mobile 2" />
          </Form.Item>
        );
      },
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      width: '150px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['email', record.key]}
            fieldKey={['email', record.key]}
            style={{
              margin: 0,
            }}
          >
            <Input placeholder="Email" />
          </Form.Item>
        );
      },
    },
    {
      title: 'Address 1',
      dataIndex: 'address_1',
      key: 'address_1',
      width: '150px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['address_1', record.key]}
            fieldKey={['address_1', record.key]}
            style={{
              margin: 0,
            }}
          >
            <Input placeholder="Address 1" />
          </Form.Item>
        );
      },
    },
    {
      title: 'Address 2',
      dataIndex: 'address_2',
      key: 'address_2',
      width: '150px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['address_2', record.key]}
            fieldKey={['address_2', record.key]}
            style={{
              margin: 0,
            }}
          >
            <Input placeholder="Address 2" />
          </Form.Item>
        );
      },
    },
    {
      title: 'City',
      dataIndex: 'city',
      key: 'city',
      width: '150px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['city', record.key]}
            fieldKey={['city', record.key]}
            style={{
              margin: 0,
            }}
          >
            <Input placeholder="City" />
          </Form.Item>
        );
      },
    },
    {
      title: 'State',
      dataIndex: 'state',
      key: 'state',
      width: '150px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['state', record.key]}
            fieldKey={['state', record.key]}
            style={{
              margin: 0,
            }}
          >
            <Select>
              <Option value="TN">Tamil Nadu</Option>
              <Option value="KL">Kerala</Option>
            </Select>
          </Form.Item>
        );
      },
    },
    {
      title: 'Pin Code',
      dataIndex: 'pin_code',
      key: 'pin_code',
      width: '150px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['pin_code', record.key]}
            fieldKey={['pin_code', record.key]}
            style={{
              margin: 0,
            }}
          >
            <Input placeholder="Pin Code" />
          </Form.Item>
        );
      },
    },
    {
      title: 'Bank',
      dataIndex: 'bank_name',
      key: 'bank_name',
      width: '150px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['bank_name', record.key]}
            fieldKey={['bank_name', record.key]}
            style={{
              margin: 0,
            }}
          >
            <Input placeholder="Bank" />
          </Form.Item>
        );
      },
    },
    {
      title: 'Account No',
      dataIndex: 'account_number',
      key: 'account_number',
      width: '200px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['account_number', record.key]}
            fieldKey={['account_number', record.key]}
            style={{
              margin: 0,
            }}
          >
            <Input placeholder="Account No" />
          </Form.Item>
        );
      },
    },
    {
      title: 'Branch',
      dataIndex: 'branch',
      key: 'branch',
      width: '150px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['branch', record.key]}
            fieldKey={['branch', record.key]}
            style={{
              margin: 0,
            }}
          >
            <Input placeholder="Branch" />
          </Form.Item>
        );
      },
    },
    {
      title: 'IFSC Code',
      dataIndex: 'ifsc_code',
      key: 'ifsc_code',
      width: '150px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['ifsc_code', record.key]}
            fieldKey={['ifsc_code', record.key]}
            style={{
              margin: 0,
            }}
          >
            <Input placeholder="IFSC Code" />
          </Form.Item>
        );
      },
    },
    {
      title: 'Id Card No',
      dataIndex: 'card_number',
      key: 'card_number',
      width: '150px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['card_number', record.key]}
            fieldKey={['card_number', record.key]}
            style={{
              margin: 0,
            }}
          >
            <Input placeholder="Id Card No" />
          </Form.Item>
        );
      },
    },
    {
      title: 'Exp. Date',
      dataIndex: 'card_validity_end',
      key: 'card_validity_end',
      width: '150px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['card_validity_end', record.key]}
            fieldKey={['card_validity_end', record.key]}
            style={{
              margin: 0,
            }}
          >
            <DatePicker format={Config.DATE_FORMAT_INPUT} />
          </Form.Item>
        );
      },
    },
    {
      title: 'DRA Number',
      dataIndex: 'dra_number',
      key: 'dra_number',
      width: '150px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['dra_number', record.key]}
            fieldKey={['dra_number', record.key]}
            style={{
              margin: 0,
            }}
          >
            <Input placeholder="DRA Number" />
          </Form.Item>
        );
      },
    },
    {
      title: 'Training Period',
      dataIndex: 'dra_training_period',
      key: 'dra_training_period',
      width: '250px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['dra_training_period', record.key]}
            fieldKey={['dra_training_period', record.key]}
            style={{
              margin: 0,
            }}
          >
            <RangePicker format={Config.DATE_FORMAT_INPUT} />
          </Form.Item>
        );
      },
    },
    {
      title: 'DRA Status',
      dataIndex: 'dra_status',
      key: 'dra_status',
      width: '150px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['dra_status', record.key]}
            fieldKey={['dra_status', record.key]}
            style={{
              margin: 0,
            }}
          >
            <Select placeholder="Please select">
              {[
                'UNTRAINED',
                'PURSING',
                'TRAINED',
                'FAIL',
                'PASS',
                'CERTIFIED',
              ].map((dra_status_option) => (
                <Select.Option
                  key={dra_status_option}
                  value={dra_status_option}
                >
                  {dra_status_option}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        );
      },
    },
    {
      title: 'PVC Number',
      dataIndex: 'pvc_number',
      key: 'pvc_number',
      width: '150px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['pvc_number', record.key]}
            fieldKey={['pvc_number', record.key]}
            style={{
              margin: 0,
            }}
          >
            <Input placeholder="PVC Number" />
          </Form.Item>
        );
      },
    },
    {
      title: 'PVC Exp. Date',
      dataIndex: 'pvc_validity_end',
      key: 'pvc_validity_end',
      width: '150px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['pvc_validity_end', record.key]}
            fieldKey={['pvc_validity_end', record.key]}
            style={{
              margin: 0,
            }}
          >
            <DatePicker format={Config.DATE_FORMAT_INPUT} />
          </Form.Item>
        );
      },
    },
    {
      title: 'RAC Mobility Id',
      dataIndex: 'rac_mobility_id',
      key: 'rac_mobility_id',
      width: '150px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['rac_mobility_id', record.key]}
            fieldKey={['rac_mobility_id', record.key]}
            style={{
              margin: 0,
            }}
          >
            <Input placeholder="RAC Mobility Id" />
          </Form.Item>
        );
      },
    },
    {
      title: 'CC Mobility Id',
      dataIndex: 'cc_mobility_id',
      key: 'cc_mobility_id',
      width: '150px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['cc_mobility_id', record.key]}
            fieldKey={['cc_mobility_id', record.key]}
            style={{
              margin: 0,
            }}
          >
            <Input placeholder="CC Mobility Id" />
          </Form.Item>
        );
      },
    },
    {
      title: 'DID Number',
      dataIndex: 'did_number',
      key: 'did_number',
      width: '150px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['did_number', record.key]}
            fieldKey={['did_number', record.key]}
            style={{
              margin: 0,
            }}
          >
            <Input placeholder="DID Number" />
          </Form.Item>
        );
      },
    },
    {
      title: 'Insurance Provider',
      dataIndex: 'provider',
      key: 'provider',
      width: '150px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['provider', record.key]}
            fieldKey={['provider', record.key]}
            style={{
              margin: 0,
            }}
          >
            <Select placeholder="Please select">
              {['STAR', 'UIIC'].map((provider_option) => (
                <Select.Option key={provider_option} value={provider_option}>
                  {provider_option}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        );
      },
    },
    {
      title: 'Policy Period',
      dataIndex: 'policy_period',
      key: 'policy_period',
      width: '250px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['policy_period', record.key]}
            fieldKey={['policy_period', record.key]}
            style={{
              margin: 0,
            }}
          >
            <RangePicker format={Config.DATE_FORMAT_INPUT} />
          </Form.Item>
        );
      },
    },
    {
      title: 'Policy Type',
      dataIndex: 'type',
      key: 'type',
      width: '150px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['type', record.key]}
            fieldKey={['type', record.key]}
            style={{
              margin: 0,
            }}
          >
            <Select placeholder="Please select">
              {['INDIVIDUAL', 'FAMILY'].map((type_option) => (
                <Select.Option key={type_option} value={type_option}>
                  {type_option}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        );
      },
    },
    {
      title: 'Sum Insured',
      dataIndex: 'sum_insured',
      key: 'sum_insured',
      width: '150px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['sum_insured', record.key]}
            fieldKey={['sum_insured', record.key]}
            style={{
              margin: 0,
            }}
          >
            <InputNumber
              // max={}
              formatter={(value) => formatAmount(value)}
              parser={(value) => value.replace(/(,*)/g, '')}
              style={{
                width: '170px',
              }}
            />
          </Form.Item>
        );
      },
    },
    {
      title: 'Date Of Relieve',
      dataIndex: 'date_of_relieving',
      key: 'date_of_relieving',
      width: '150px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['date_of_relieving', record.key]}
            fieldKey={['date_of_relieving', record.key]}
            style={{
              margin: 0,
            }}
          >
            <DatePicker format={Config.DATE_FORMAT_INPUT} />
          </Form.Item>
        );
      },
    },
    {
      title: 'Reference Name',
      dataIndex: 'reference_name',
      key: 'reference_name',
      width: '150px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['reference_name', record.key]}
            fieldKey={['reference_name', record.key]}
            style={{
              margin: 0,
            }}
          >
            <Input placeholder="Reference Name" />
          </Form.Item>
        );
      },
    },
    {
      title: 'Reference Contact',
      dataIndex: 'reference_contact',
      key: 'reference_contact',
      width: '150px',
      render: (_, record) => {
        return (
          <Form.Item
            name={['reference_contact', record.key]}
            fieldKey={['reference_contact', record.key]}
            style={{
              margin: 0,
            }}
          >
            <Input placeholder="Reference Contact" />
          </Form.Item>
        );
      },
    },
  ];

  useEffect(() => {
    if (!dataSource.length) {
      setDataSource([1, 2].map((i) => getRow()));
    }
  }, [dataSource]);

  const getRow = () => {
    return {
      key: guid(),
      location: 0,
      first_name: '',
      last_name: '',
      designation: 0,
      portfolio: 0,
      aadhar: '',
      pan: '',
      phone_1: '',
      date_of_joining: '',
      phone_2: '',
      email: '',
      address_1: '',
      address_2: '',
      city: '',
      state: '',
      pin_code: '',
      bank_name: '',
      account_number: '',
      branch: '',
      ifsc_code: '',
      card_number: '',
      card_validity_end: '',
      dra_number: '',
      dra_training_start: '',
      dra_training_end: '',
      date_of_relieving: '',
      reference_name: '',
      reference_contact: '',
    };
  };

  const addRow = () => {
    setDataSource([...dataSource, getRow()]);
  };

  const removeRow = (guid) => {
    const updatedDataSource = dataSource.filter((i) => i.key !== guid);
    setDataSource(updatedDataSource);
  };

  const restForm = () => {
    form.resetFields();
    setDataSource([]);
  };

  return (
    <Form
      form={form}
      onFinish={(values) => {
        const keys = dataSource.map((i) => i.key);
        onSave(values, keys, (status) => {
          console.log('done');
          setInProgress(false);
          if (status) {
            //success
            restForm();
          }
        });
        setInProgress(true);
      }}
      initialValues={{ status: true }}
      // onValuesChange={(changedValues, allValues) => {
      //   console.log(changedValues, allValues);
      //   if ((typeof changedValues["card_number"] !== 'undefined')) {
      //     const key = Object.keys(changedValues["card_number"])[0];
      //     const val = Object.values(changedValues["card_number"])[0];
      //     if (val !== '' && (allValues.card_validity_end[key] === null)) {
      //       form.getFieldInstance(['card_validity_end',key]).validateStatus = 'error';
      //     }
      //   }
      // }}
      className="bulkEmployeeInsertForm"
    >
      <Row>
        <Col xs={24} style={{ textAlign: 'right', marginBottom: '.5rem' }}>
          <Table
            size="small"
            bordered
            showHeader={true}
            pagination={false}
            columns={columns}
            dataSource={dataSource}
            scroll={{ x: 2000 }}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Button type="secondary" onClick={addRow}>
            + Add Row
          </Button>
        </Col>
        <Col xs={12} style={{ textAlign: 'right', marginBottom: '.5rem' }}>
          <Space>
            <Popconfirm
              title="Are you sure to reset all row data?"
              onConfirm={restForm}
              onCancel={() => {}}
              okText="Yes"
              cancelText="No"
            >
              <Button type="secondary">Reset</Button>
            </Popconfirm>
            <Button type="primary" htmlType="submit" disabled={inProgress}>
              Add Employees
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
};

export default EmployeeBulkInsert;
